document.addEventListener('DOMContentLoaded', function() {
    // Function to switch steps
    var switchSteps = function(className, stepClass) {
        var reviewStep = document.querySelectorAll('.review-step');
        reviewStep.forEach(function(el) {
            el.classList.remove('active');
        });

        className.forEach(function(el) {
            el.classList.add('active');
        });

        if (stepClass) {
            stepClass.forEach(function(el) {
                el.classList.add('active');
            });
        }
    };

    if (document.querySelectorAll('.c-survey-stepper').length > 0) {
        // Event listeners for #review-yes and #review-no
        document.getElementById('review-yes').addEventListener('click', function(e) {
            e.preventDefault();
            switchSteps(document.querySelectorAll('.step-yes'), document.querySelectorAll('.step-answers-i'));
        });

        document.getElementById('review-no').addEventListener('click', function(e) {
            e.preventDefault();
            switchSteps(document.querySelectorAll('.step-no'), document.querySelectorAll('.step-answers-i'));
        });

        var stepFormTitle = document.querySelectorAll('.step-form-title');
        var formTitles = [
            {
                value: 'yes-1',
                title: 'Share what you liked about the article.',
            },
            {
                value: 'yes-2',
                title: 'It was helpful, but I still have questions'
            },
            {
                value: 'no-1',
                title: 'This article contains incorrect information'
            },
            {
                value: 'no-2',
                title: 'I found this information too complicated'
            },
            {
                value: 'no-3',
                title: 'I have a question after reading this article'
            }
        ];

        formTitles.forEach(function(desc) {
            document.getElementById(desc.value).addEventListener('click', function(e) {
                e.preventDefault();
                stepFormTitle.innerHTML = desc.title;
                switchSteps(document.querySelectorAll('.step-form'), document.querySelectorAll('.step-form-i'));
            });
        });

        ['review-yes', 'review-no'].forEach(function(id) {
            document.getElementById(id).addEventListener('click', function(e) {
                e.preventDefault();
                document.querySelector('input[name="helpful"]').value = this.getAttribute('data-select');
            });
        });

        ['yes-1', 'yes-2', 'no-1', 'no-2', 'no-3'].forEach(function(id) {
            document.getElementById(id).addEventListener('click', function(e) {
                e.preventDefault();
                document.querySelector('input[name="response_type"]').value = this.innerHTML;
            });
        });

        // Form submit click event
        document.getElementById('review-form').addEventListener('click', function(e) {
            e.preventDefault();

            if (Global.ajaxSubmitErrors(this.closest('form'))) {
                return false;
            }

            var base_site_url = document.getElementById('base_site_url').value;
            var data = new URLSearchParams(new FormData(document.getElementById('artical-helpful'))).toString(); // Form data

            fetch(base_site_url + '/wp-content/themes/asbestos/ajax/article_helpful.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: data
            })
            .then(response => response.text())
            .then(data => {
                if (data) {
                    switchSteps(document.querySelectorAll('.step-thanks'));
                    var reviewStepIndicator = document.querySelectorAll('.review-step-indicator li');
                    reviewStepIndicator.forEach(function(el) {
                        el.classList.add('removeColor');
                    });
                }
            });
        });
    }
});
